import React from "react";
import ServiceIconBase, { ServiceIconProps } from "./ServiceIconBase";

/** Laptop seen head-on — "Reparación de computadores". */
export const ComputerRepairIcon: React.FC<ServiceIconProps> = ({ size }) => (
  <ServiceIconBase size={size}>
    <rect x="4" y="5" width="16" height="11" rx="1.5" />
    <path d="M2 19.5h20" />
  </ServiceIconBase>
);

export default ComputerRepairIcon;
